import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
// import lojas from '@/domains/configuracoes/lojas/router/routes'
import usuarios from '@/domains/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/configuracoes/permissoes/router/routes'
import planos from '@/domains/configuracoes/planos/router/routes'
import dominios from '@/domains/configuracoes/dominios/router/routes'
import notificacoes from '@/domains/auxiliares/notificacoes/router/routes'
import ajuda from '@/domains/auxiliares/ajuda/router/routes'
import carteira from '@/domains/carteira/router/routes'

import usuariosLogs from '@/domains/relatorios/usuarios_logs/router/routes'

const Interno = () => import('@/shared/components/layout/Interno')
const Externo = () => import('../shared/layouts/adminlte/components/ExternoBarra')

/* busca todas as rotas contidas em arquivos com o nome routes.js no módulo */
let childrenRoutes = []
const paths = require.context('../', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => {
            childrenRoutes.push(val)
        })
    }
})
/**** */

const routes = [
    {
        path: '',
        component: Externo,
        children: [
            {
                name: 'visualizarDocumentoHash',
                path: '/assinatura_digital/documentos/visualizar_documento_hash/:hash',
                alias: '/assinatura_digital/d/:hash',
                meta: { 
                    public: true 
                },
                component: () => import('../domains/documentos/views/Exibir')
            },
            {
                name: 'visualizarModeloHash',
                path: '/assinatura_digital/modelos/visualizar_modelo_hash/:hash',
                alias: '/assinatura_digital/m/:hash',
                meta: { 
                    public: true 
                },
                component: () => import('../domains/modelos/views/GerarDocumentoCompartilhado')
            },
            {
                name: 'AssinarDocumento',
                path: '/assinatura_digital/assinar/:hash',
                meta: { 
                    public: true 
                },
                component: () => import('../domains/documentos/views/Assinar')
            },
            {
                name: 'solicitarEmail',
                path: '/assinatura_digital/doc/:hash',
                meta: { 
                    public: true 
                },
                component: () => import('../domains/documentos/views/SolicitarEmail')
            }, 
            {
                name: 'VerificarAutenticidadeDocumento',
                path: '/assinatura_digital/documentos/verificar_autenticidade/:uid?',
                alias: '/assinatura_digital/a/:uid?',
                meta: { 
                    public: true 
                },
                component: () => import('../domains/documentos/views/VerificarAutenticidade')
            },
            {
                name: 'Termos',
                path: '/assinatura_digital/termos',
                meta: {
                    public: true
                },
                component: () => import('../domains/sistema/views/Termos')
            },
            {
                name: 'areaAssinante',
                path: '/assinatura_digital/area_assinante',
                meta: {
                    public: true
                },
                component: () => import('../domains/area_assinante/views/Index')
            }
        ],
    },
    {
        path: '/assinatura_digital',
        component: Interno,
        children: childrenRoutes,
    },
    {
        path: '/assinatura_digital/sistema/acessar_erp',
        redirect: '/inicio'
    },
    ...formataRotasGlobais('assinatura_digital', dominios),
    // ...formataRotasGlobais('assinatura_digital', lojas),
    ...formataRotasGlobais('assinatura_digital', usuarios),
    ...formataRotasGlobais('assinatura_digital', gruposUsuarios),
    ...formataRotasGlobais('assinatura_digital', permissoes),
    ...formataRotasGlobais('assinatura_digital', planos),
    ...formataRotasGlobais('assinatura_digital', notificacoes),
    ...formataRotasGlobais('assinatura_digital', ajuda),
    ...formataRotasGlobais('assinatura_digital', carteira),
    ...formataRotasGlobais('assinatura_digital', usuariosLogs),
    {
        name: 'impressaoRelatorioAssinaturaDigital',
        path: '/assinatura_digital/relatorios/:tipo/gerar',
        component: () => import('@/shared/components/ui/Relatorio')
    },
]

router.addRoutes(routes)
export default router

